import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./reduxStore/store";
import { Provider } from "react-redux";
import { CssBaseline } from "@mui/material";
import { ColorModeContextProvider } from "./contexts";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>      
        <ColorModeContextProvider>
          <CssBaseline enableColorScheme />          
            <App /> 
        </ColorModeContextProvider> 
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
